import React from "react";
import { IconX } from "@tabler/icons-react";
import clsx from "clsx";

const ImageThumbnail = ({
  imageUrl: imgUrl,
  imageFile,
  ...props
}: {
  imageUrl: string;
  imageFile?: File;
  onRemove: (image: File | string) => void;
}) => {
  return (
    <div className="relative group">
      <div
        className={clsx(
          "border w-[100px] min-h-[100px] max-h-[100px] items-center md:h-auto",
          "flex min-w-30 justify-center relative rounded-md overflow-hidden",
          imageFile ? "border-indigo-600 shadow-lg" : "border-gray-100"
        )}
      >
        <img alt="" src={imgUrl} className="object-cover aspect-1" />
      </div>
      <div
        className={clsx(
          "hidden group-hover:flex absolute",
          "-top-1 -right-1 bg-opacity-60 transition justify-center items-center gap-1"
        )}
      >
        <button
          type="button"
          className={clsx(
            "w-6 h-6 text-white opacity-100 rounded-full border border-gray-300 bg-white",
            "flex justify-center items-center -right-1 top-0 hover:bg-gray-50 transition"
          )}
          onClick={() => props.onRemove(imageFile || imgUrl)}
        >
          <IconX className="text-gray-700 w-4 h-4 rotate-90" stroke={3} />
        </button>
      </div>
    </div>
  );
};

export default ImageThumbnail;
